// src/Pages/Login.jsx

import React, {
  useState,
} from "react";

import {
  ShieldCheck,
  LockKeyhole,
  Mail,
  Eye,
  EyeOff,
  ArrowRight,
  KeyRound,
  Sparkles,
} from "lucide-react";

import {
  useNavigate,
} from "react-router-dom";

import "../css/login.css";

import logo from "../assets/logo.png";

export default function Login() {

  const nav =
    useNavigate();

  /* ========================================
     HARD CODED AUTH
  ======================================== */

  const ADMIN_EMAIL =
    "admin@rcsgy.com";

  const ADMIN_PASSWORD =
    "rcsadmin123";

  const SECURITY_COLOR =
    "yellow";

  const SECURITY_HOBBY =
    "sleep";

  /* ========================================
     STATES
  ======================================== */

  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [showPassword, setShowPassword] =
    useState(false);

  const [loginSuccess, setLoginSuccess] =
    useState(false);

  const [loginFailed, setLoginFailed] =
    useState(false);

  const [popupMessage, setPopupMessage] =
    useState("");

  const [showForgotPassword, setShowForgotPassword] =
    useState(false);

  const [favoriteColor, setFavoriteColor] =
    useState("");

  const [favoriteHobby, setFavoriteHobby] =
    useState("");

  const [forgotSuccess, setForgotSuccess] =
    useState(false);

  /* ========================================
     LOGIN
  ======================================== */

  const onSubmit =
    async (e) => {

      e.preventDefault();

      setLoading(true);

      setLoginFailed(false);

      setLoginSuccess(false);

      await new Promise((resolve) =>
        setTimeout(resolve, 1200)
      );

      if (
        email === ADMIN_EMAIL &&
        password === ADMIN_PASSWORD
      ) {

        setPopupMessage(
          "Login Success!"
        );

        setLoginSuccess(true);

localStorage.setItem(
  "rcs_pos_auth",
  JSON.stringify({
    loggedIn: true,
    loginTime: Date.now(),
  })
);
        setTimeout(() => {

          nav("/");

        }, 1200);

      } else {

        setPopupMessage(
          "Please verify your username and password."
        );

        setLoginFailed(true);

        setTimeout(() => {
          setLoginFailed(false);
        }, 2600);

      }

      setLoading(false);
    };

  /* ========================================
     FORGOT PASSWORD
  ======================================== */

  const handleForgotPassword =
    (e) => {

      e.preventDefault();

      if (
        favoriteColor
          .toLowerCase()
          .trim() ===
          SECURITY_COLOR &&
        favoriteHobby
          .toLowerCase()
          .trim() ===
          SECURITY_HOBBY
      ) {

        setForgotSuccess(true);

        setTimeout(() => {

          setPassword(
            ADMIN_PASSWORD
          );

          setShowForgotPassword(false);

          setForgotSuccess(false);

          setPopupMessage(
            "Password Restored!"
          );

          setLoginSuccess(true);

          setTimeout(() => {
            setLoginSuccess(false);
          }, 2400);

        }, 1500);

      } else {

        setPopupMessage(
          "Security answers incorrect."
        );

        setLoginFailed(true);

        setTimeout(() => {
          setLoginFailed(false);
        }, 2600);

      }

    };

  return (
    <div className="modern-login-page">

      {/* BACKGROUND BLOBS */}

      <div className="modern-login-blob one" />
      <div className="modern-login-blob two" />
      <div className="modern-login-blob three" />

      {/* MAIN GRID */}

      <div className="modern-login-grid">

        {/* LEFT */}

        <div className="modern-login-left">

          <div className="modern-login-pill">
            <ShieldCheck size={16} />
            RCS POS SYSTEM
          </div>

          <h1 className="modern-login-heading">
            Welcome
            Back.
          </h1>

          <p className="modern-login-description">
            Access your RCS POS
            dashboard, inventory,
            transactions,
            customers and
            business analytics
            from one premium
            workspace.
          </p>

          <div className="modern-login-feature-list">

            <div className="modern-login-feature">

              <div className="modern-login-feature-icon">
                💳
              </div>

              <div>
                <strong>
                  Sales &
                  Transactions
                </strong>

                <span>
                  Monitor business
                  activity in real
                  time.
                </span>
              </div>
            </div>

            <div className="modern-login-feature">

              <div className="modern-login-feature-icon">
                📦
              </div>

              <div>
                <strong>
                  Inventory
                  Control
                </strong>

                <span>
                  Track stock,
                  products and
                  low inventory
                  alerts.
                </span>
              </div>
            </div>

            <div className="modern-login-feature">

              <div className="modern-login-feature-icon">
                📊
              </div>

              <div>
                <strong>
                  Analytics &
                  Reports
                </strong>

                <span>
                  View business
                  performance
                  instantly.
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT */}

        <div className="modern-login-card">

          {/* LOGO */}

          <div className="modern-login-logo-wrap">

            <div className="modern-login-logo-ring" />

            <div className="modern-login-logo-core">

              <img
                src={logo}
                alt="RCS Logo"
              />

            </div>
          </div>

          {/* HEADER */}

          <div className="modern-login-card-header">

            <h2>
              Sign In
            </h2>

            <p>
              Please enter your
              credentials to
              continue.
            </p>

          </div>

          {/* FORM */}

          <form
            onSubmit={
              onSubmit
            }
            className="modern-login-form"
          >

            {/* EMAIL */}

            <div className="modern-login-group">

              <label>
                Email Address
              </label>

              <div className="modern-login-input-wrap">

                <Mail size={18} />

                <input
                  type="email"
                  value={email}
                  onChange={(e) =>
                    setEmail(
                      e.target.value
                    )
                  }
                  placeholder="Enter your email"
                  autoFocus
                />
              </div>
            </div>

            {/* PASSWORD */}

            <div className="modern-login-group">

              <label>
                Password
              </label>

              <div className="modern-login-input-wrap">

                <LockKeyhole size={18} />

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  value={password}
                  onChange={(e) =>
                    setPassword(
                      e.target.value
                    )
                  }
                  placeholder="Enter your password"
                />

                <button
                  type="button"
                  className="modern-password-toggle"
                  onClick={() =>
                    setShowPassword(
                      !showPassword
                    )
                  }
                >
                  {showPassword ? (
                    <EyeOff size={18} />
                  ) : (
                    <Eye size={18} />
                  )}
                </button>
              </div>
            </div>

            {/* FORGOT */}

            <button
              type="button"
              className="modern-forgot-password-btn"
              onClick={() =>
                setShowForgotPassword(
                  true
                )
              }
            >
              <KeyRound size={16} />
              Forgot Password?
            </button>

            {/* SUBMIT */}

            <button
              type="submit"
              className="modern-login-submit"
              disabled={loading}
            >
              {loading ? (
                "Signing In..."
              ) : (
                <>
                  Continue
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      {/* SUCCESS */}

      {loginSuccess && (
        <div className="modern-login-popup success">

          <div className="modern-login-popup-icon success-icon">
            ✓
          </div>

          <h3>
            Access Granted
          </h3>

          <p>
            {popupMessage}
          </p>
        </div>
      )}

      {/* ERROR */}

      {loginFailed && (
        <div className="modern-login-popup error">

          <div className="modern-login-popup-icon error-icon">
            ✕
          </div>

          <h3>
            Login Failed
          </h3>

          <p>
            {popupMessage}
          </p>
        </div>
      )}

      {/* LOADER */}

      {loading && (
        <div className="modern-login-overlay">

          <div className="modern-login-overlay-card">

            <div className="modern-login-loading-wrapper">

              <div className="modern-login-loading-ring" />

              <div className="modern-login-loading-core">

                <img
                  src={logo}
                  alt="RCS"
                />

              </div>
            </div>

            <h2>
              Welcome Back
            </h2>

            <p>
              Preparing your
              workspace...
            </p>
          </div>
        </div>
      )}

      {/* FORGOT PASSWORD MODAL */}

      {showForgotPassword && (
        <div className="modern-forgot-overlay">

          <div className="modern-forgot-card">

            <div className="modern-forgot-top">

              <div className="modern-login-pill">
                <Sparkles size={16} />
                Account Recovery
              </div>

            </div>

            <h2>
              Recover Password
            </h2>

            <p>
              Answer the security
              questions to restore
              your account access.
            </p>

            <form
              onSubmit={
                handleForgotPassword
              }
              className="modern-login-form"
            >

              <div className="modern-login-group">

                <label>
                  Favorite Color
                </label>

                <div className="modern-login-input-wrap">

                  <input
                    type="text"
                    value={
                      favoriteColor
                    }
                    onChange={(e) =>
                      setFavoriteColor(
                        e.target.value
                      )
                    }
                    placeholder="Enter favorite color"
                  />
                </div>
              </div>

              <div className="modern-login-group">

                <label>
                  Favorite Hobby
                </label>

                <div className="modern-login-input-wrap">

                  <input
                    type="text"
                    value={
                      favoriteHobby
                    }
                    onChange={(e) =>
                      setFavoriteHobby(
                        e.target.value
                      )
                    }
                    placeholder="Enter favorite hobby"
                  />
                </div>
              </div>

              <div className="modern-forgot-actions">

                <button
                  type="button"
                  className="modern-forgot-cancel"
                  onClick={() =>
                    setShowForgotPassword(
                      false
                    )
                  }
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="modern-login-submit"
                >
                  Recover Password
                </button>
              </div>
            </form>

            {forgotSuccess && (
              <div className="modern-forgot-success">
                Password Restored:
                <strong>
                  {" "}
                  rcsadmin123
                </strong>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}